import { atom } from 'recoil';

export const AllocationTypeAtom = atom<'deallocate' | 'create' | 'edit' | ''>({
	key: 'allocationType',
	default: '',
});
